// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageProps } from "@insite/mobius/LazyImage";
import { LinkProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ChevronRightSolid from "@werner/XDL/Icons/ChevronRightSolid";
import { color, createLinkIconStyles, ellipsis, xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

export interface QuickLinkStyles {
    quickLinkWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    image?: LazyImageProps;
    textWrapper?: InjectableCss;
    text?: TypographyProps;
    link?: LinkProps;
}

const quickLinkCardStyles: QuickLinkStyles = {
    quickLinkWrapper: {
        css: css`
            height: 144px;
            box-shadow: 0 0 15px 0 ${color("primary", 0.15)};
            border: 1px solid ${color("primary", 0.05)};
            display: flex;
            border-radius: 3px;
            flex: 1;
            max-width: 285px;

            ${xScreen("lte", "md")} {
                min-width: 280px;
                height: 120px;
            }
        `,
    },
    imageWrapper: {
        css: css`
            background-color: ${color("primary.main")};
            border-radius: 3px 0 0 3px;
            width: 88px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
    image: {
        width: "40px",
        css: css`
            width: 40px;
            height: auto;
            max-height: 42px;
            background-color: transparent;
            color: ${color("common.white")};
            padding: 0;
        `,
    },
    textWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-left: 24px;
            padding-right: 8px;
            width: calc(100% - 88px);
            align-items: flex-start;
            background: ${color("common.white")};
        `,
    },
    text: {
        variant: "h5",
        as: "p",
        css: css`
            ${ellipsis(2)};
            ${xScreen("lte", "md")} {
                ${ellipsis(1)};
            }
        `,
    },
    link: {
        ...createLinkIconStyles(ChevronRightSolid, {
            color: "secondary",
            icon: {
                position: "right",
                iconProps: {
                    size: 8,
                    css: css`
                        margin-left: 4px;
                    `,
                },
            },
            typographyProps: {
                size: 16,
                weight: 500,
                css: css`
                    letter-spacing: 0;
                    line-height: 30px;
                    ${ellipsis(1)};
                `,
            },
        }),
    },
};

export default quickLinkCardStyles;
